import I18n from 'components/I18n'
import _Search from 'components/Section/Search'
import { ApiCurrency } from 'data/Currencies/types'
import messages from 'lang'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import _Rows from 'scenes/Cashflow/Rows'
import styled from 'styled-components'

import { Divider, Empty } from '../Deposit/Crypto/styles'

const Search = styled(_Search)`
  display: flex;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 24px;
`

const StyledDivider = styled(Divider)`
  width: 100%;
`

const Rows = styled(_Rows)`
  padding: 2rem 0;
`

const getCurrenciesFiltered = (currencies, query) =>
  currencies.filter(
    ({ displaySymbol, symbol }) =>
      symbol.toLocaleLowerCase().includes(query.toLocaleLowerCase()) ||
      displaySymbol.toLocaleLowerCase().includes(query.toLocaleLowerCase())
  )

type Props = {
  currencies: ApiCurrency[]
  onItemClick: (currency: string, query: string) => void
}
const CryptoOptions = ({ currencies, onItemClick }: Props) => {
  const [query, setQuery] = useState('')
  const currenciesFiltered = getCurrenciesFiltered(currencies, query)
  const type = 'currency'
  const intl = useIntl()

  const rows = currenciesFiltered.map((currencyItem) => ({
    onClick: () => onItemClick(currencyItem.symbol, query),
    symbol: currencyItem.symbol,
    tight: true,
    title: currencyItem.name,
    type
  }))

  return (
    <>
      <Search
        placeholder={intl.formatMessage(messages.placeholder_search_coins)}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <StyledDivider />
      {rows.length > 0 && <Rows rows={rows} />}
      {rows.length === 0 && (
        <Empty>
          <I18n data={messages.no_results} />
        </Empty>
      )}
    </>
  )
}

export default CryptoOptions
